import { useState } from "react";
import styled from "styled-components";
import { BASIC_LINE, BASIC_ORANGE } from "../../../constants/colors";
import { Button } from "../../atoms/Button";
import { PaymentMethod } from "../../pages/order_confirmation/hook";
import { PaymentSelectModal } from "../modal/PaymentSelectModal";

type Props = {
  selectedPaymentMethod: PaymentMethod | null;
  onChangePaymentMethod: (paymentMethod: PaymentMethod) => void;
  isDisabled?: boolean;
};

export const PaymentSelection: React.FC<Props> = ({
  selectedPaymentMethod,
  onChangePaymentMethod,
  isDisabled,
}) => {
  const [showPaymentSelectModal, setShowPaymentSelectModal] =
    useState<boolean>(false);

  return (
    <>
      <ButtonContainer>
        {selectedPaymentMethod === null && (
          <Button
            btnStyle="payment"
            text="決済方法選択"
            onClick={() => setShowPaymentSelectModal(true)}
            disabled={isDisabled}
          />
        )}
      </ButtonContainer>

      <PaymentSelectionContainer>
        {selectedPaymentMethod !== null && (
          <PaymentMethodInformationContainer>
            <PaymentMethodInformationTitle>
              決済方法
            </PaymentMethodInformationTitle>

            <PaymentMethodInformation>
              <div>{selectedPaymentMethod.valueOf()}</div>

              <Button
                size="xxs"
                btnStyle="secondary"
                text="決済方法変更"
                onClick={() => setShowPaymentSelectModal(true)}
              />
            </PaymentMethodInformation>

            {selectedPaymentMethod === PaymentMethod.AdvancedPayment && (
              <AdvancedPaymentMessage>
                「ご注文の決済手続きを行う」ボタンを
                <br />
                押した後、決済完了までブラウザを
                <br />
                閉じないでください
              </AdvancedPaymentMessage>
            )}
          </PaymentMethodInformationContainer>
        )}
      </PaymentSelectionContainer>

      <PaymentSelectModal
        isOpen={showPaymentSelectModal}
        handleClose={() => setShowPaymentSelectModal(false)}
        selectedPaymentMethod={selectedPaymentMethod}
        onSelectPaymentMethod={onChangePaymentMethod}
      />
    </>
  );
};

const PaymentSelectionContainer = styled.div``;

const PaymentMethodInformationContainer = styled.div``;

const PaymentMethodInformationTitle = styled.div`
  text-align: left;
  margin: 0 16px 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${BASIC_LINE};
`;

const PaymentMethodInformation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 16px 16px;
  button {
    width: 100px;
  }
`;

const AdvancedPaymentMessage = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  padding: 20px 24px;
  color: ${BASIC_ORANGE};
  background-color: #fdf4f0;
  margin-top: 25px;
`;

const ButtonContainer = styled.div`
  button {
    height: auto;
    line-height: 1;
    padding: 20px 0 18px;
    font-weight: 600;
  }
`;
